import React from 'react';
import { t } from 'Src/i18n';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { Modal } from 'Components/frameworks/modal/Modal';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Button } from 'Components/frameworks/button/Button';
type Props = {
  onClose: () => void;
};
export const FailedPaymentModal = ({ onClose }: Props) => (
  <Modal closeLabel={t('common.close')} onClose={onClose} size="small">
    <div className="flex flex-col items-center justify-center p-25">
      <div className="flex flex-col items-center text-orange">
        <Icon name={ICONS.CREDIT_CARD} width="5.25rem" className="w-full pb-95" />
        <span className="text-24">{t('booking.banking.error.paymentFailed.popinInfo1')}</span>
      </div>
      <span className="pb-20 text-14">{t('booking.banking.error.paymentFailed.popinInfo2')}</span>
      <span className="text-14">{t('booking.banking.error.paymentFailed.popinInfo3')}</span>
      <span className="flex items-center text-18 text-saffron">
        <Icon name={ICONS.PHONE} /> {t('booking.counterProposalPopIn.callCenterNumber')}
      </span>
      <span className="pb-30 text-12">({t('navigationBar.contact.toll')})</span>
      <Button colorBg={COLORS.TURQUOISE} onClick={onClose}>
        {t('booking.priceCalendar.closePopin')}
      </Button>
    </div>
  </Modal>
);
